export default __webpack_public_path__ + "static/media/6.316e96d6.jpg";